'use strict';

/**
 * Initialize Promo Bar - Manually initializes Slick and adds custom behavior
 */
function initPromoBar() {
    var $promoBar = $('.promo-bar');
    if (!$promoBar.length) return;

    var $carousel = $promoBar.find('.promo-bar-carousel');
    if (!$carousel.length) return;

    // Skip if already initialized
    if ($carousel.hasClass('slick-initialized')) return;

    // Read configuration from data attributes
    var $wrapper = $promoBar.find('.promo-bar-carousel-wrapper');
    var config = {
        bgColor: $promoBar.data('bg-color') || '#6d2e46',
        textColor: $promoBar.data('text-color'),
        fontMobile: $promoBar.data('font-size-mobile') || '11px',
        fontDesktop: $promoBar.data('font-size-desktop') || '14px',
        showArrowsMobile: $wrapper.data('showarrows-mobile') !== false,
        showArrowsDesktop: $wrapper.data('showarrows-desktop') !== false,
        autoScroll: $promoBar.data('auto-scroll') === true,
        interval: parseInt($promoBar.data('scroll-interval'), 10) || 5000
    };

    var autoScrollTimer = null;

    // Apply background and text colors
    $promoBar.css('background-color', config.bgColor);
    if (config.textColor) {
        $promoBar.find('.promo-bar-messages').css('color', config.textColor);
    }

    /**
     * Set constant height based on tallest message
     */
    function setConstantHeight() {
        var $messages = $carousel.find('.promo-bar-message');
        var $container = $promoBar.find('.promo-bar-container');
        var isMobile = $(window).width() < 768;
        var fontSize = isMobile ? config.fontMobile : config.fontDesktop;

        // Apply font size to all messages
        $messages.css('font-size', fontSize);

        if (isMobile) {
            var maxHeight = 0;

            // Measure each message to find the tallest
            $messages.each(function () {
                var $temp = $('<div>')
                    .css({
                        position: 'absolute',
                        visibility: 'hidden',
                        width: $carousel.width() + 'px',
                        padding: '0 20px',
                        'line-height': '1.4em',
                        'white-space': 'normal',
                        display: '-webkit-box',
                        '-webkit-line-clamp': '2',
                        '-webkit-box-orient': 'vertical',
                        overflow: 'hidden',
                        'font-size': fontSize
                    })
                    .html($(this).html())
                    .appendTo('body');

                // Use offsetHeight instead of scrollHeight to respect line-clamp
                var height = $temp[0].offsetHeight;
                if (height > maxHeight) maxHeight = height;
                $temp.remove();
            });

            // Set constant height for container
            $carousel.css('min-height', maxHeight + 'px');
            $container.css('min-height', Math.max(52, maxHeight + 24) + 'px');
        } else {
            // Desktop: reset heights
            $carousel.css('min-height', '26px');
            $container.css('min-height', '52px');
        }
    }

    /**
     * Stop auto-scroll functionality
     */
    function stopAutoScroll() {
        if (autoScrollTimer) {
            clearInterval(autoScrollTimer);
            autoScrollTimer = null;
        }
    }

    /**
     * Start auto-scroll functionality
     */
    function startAutoScroll() {
        if (!config.autoScroll || $carousel.find('.promo-bar-message').length <= 1) return;

        stopAutoScroll();
        autoScrollTimer = setInterval(function () {
            $carousel.slick('slickNext');
        }, config.interval);
    }

    // Custom SVG arrows
    var prevArrow = '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M8 2L2 8L8 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    var nextArrow = '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M2 2L8 8L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    // Initialize Slick
    $carousel.on('init', function () {
        setTimeout(function () {
            setConstantHeight();
            if (config.autoScroll) startAutoScroll();
        }, 100);
    });

    var isMobile = $(window).width() < 768;
    var showArrows = isMobile ? config.showArrowsMobile : config.showArrowsDesktop;

    $carousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: showArrows,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        speed: 300,
        infinite: true,
        autoplay: false,
        pauseOnHover: false,
        adaptiveHeight: false
    });

    // After Slick changes slides
    $carousel.on('afterChange', function () {
        if (config.autoScroll) startAutoScroll();
    });

    // Pause on hover
    $promoBar.on('mouseenter', stopAutoScroll);
    $promoBar.on('mouseleave', function () {
        if (config.autoScroll) startAutoScroll();
    });
}

module.exports = {
    initPromoBar: initPromoBar
};
